/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../../builder');

let ElementClass = require('./../../elementClass');

let ItemTpl = require('./template/item.hbs');

FormBuilder.register('checkList', function(config) {
    let self = new ElementClass(config);
    let options = config.options || [];
    let $ul = jQuery('<ul />');
    let $globalLi;

    self.insertItem = function(data = {}) {
        let $li = jQuery(ItemTpl(data));

        $ul.append($li);

        return $li;
    };

    self.render = function($wrap) {
        $globalLi = self.insertItem({label: 'Selectionner/Déselectionner', inputClass: 'global'});

        $globalLi.find('input').on('change', function() {
            let checked = jQuery(this).is(':checked');

            $ul.find('input').each(function() {
                jQuery(this).prop('checked', checked);
            });
        });

        for (let key in options) {
            if (options.hasOwnProperty(key)) {
                let option = {label: options[key], id: key};
                self.insertItem(option);
            }
        }

        $wrap.append($ul);
    };

    self.getData = function() {

    };

    return self;
});
